import { takeLatest, takeEvery, select, call, put } from 'redux-saga/effects';
import * as cnt from './constants';
import { apiSaga } from '../../../../sagas';
import { masterTemplates as apis } from '../../../../api';
import { replace } from 'react-router-redux';
import { delay } from 'redux-saga';
import R from 'ramda';


function* init({ payload: { pathname, query } }) {
  if (pathname.indexOf('master-template-list') > -1) {
    yield* apiSaga(cnt.GET_LIST, apis.getAll, [query.type]);
  }
  if (pathname.indexOf('create-master-template') > -1) {
    yield put({ type: cnt.INIT, payload: { templateType: query.type || 'policyNotes' } });
  }
}

function* getAssociatedTemplates({ payload }) {
  for (const doc of payload) {
    const { _id: id, type } = doc;
    yield* apiSaga(cnt.GET_ASSOCIATED_TEMPLATES, apis.getAssociatedTemplates, [{ id, type }]);
  }
}

function* deleteTemplate({ type, payload }) {
  yield* apiSaga(type, apis.deleteTemplate, [payload]);
}

function* renameTemplate({ type, payload }) {
  yield* apiSaga(type, apis.renameTemplate, [payload]);
}

function* createSecondaryTemplate({ type }) {
  const {
    templateType,
    templateName,
  } = yield select(state => state.contracting.masterTemplate.createNew);
  yield* apiSaga(type, apis.createInitial, [{ type: templateType, templateName }]);
}

function* routeToTemplate({ payload }) {
  yield put(replace(`/contracting/master-template/draft:${payload.newId}`));
}


export default [
  takeLatest('@@router/LOCATION_CHANGE', init),
  takeLatest(`${cnt.GET_LIST}_SUCCESS`, getAssociatedTemplates),
  takeLatest(cnt.DELETE_TEMPLATE, deleteTemplate),
  takeLatest(cnt.RENAME_TEMPLATE, renameTemplate),
  takeLatest(cnt.CREATE, createSecondaryTemplate),
  takeLatest(`${cnt.CREATE}_SUCCESS`, routeToTemplate),
];



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/__storeFiles__/sagas.js